import { render, staticRenderFns } from "./GeralRelatorioComponent.vue?vue&type=template&id=49391140&scoped=true&"
import script from "./GeralRelatorioComponent.vue?vue&type=script&lang=js&"
export * from "./GeralRelatorioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49391140",
  null
  
)

export default component.exports